module.exports = __webpack_public_path__ + "/build/web/images/custom-made-textiles@3x.026311db4a0190f712d621a9b545eb4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/custom-made-textiles@3x.jpg
// module id = 126
// module chunks = 13